import useNotifications from "@hooks/useNotifications";

const NotificationReciever = () => {
  useNotifications();

  return <></>;
};

export default NotificationReciever;
